import './campaign-card.scss';
